<template>
  <div class="container_VideosPlayForm" v-if="show">
    <div class="textMessage_VideosPlayForm">
      <span>
        {{ descripcionConfidencial }}
      </span>
    </div>
    <div class="containerClose">
      <span class="spanClose" @click="$emit('close')">
        <PIcon icon="close" type="material" size="47" />
      </span>
    </div>
    <div class="containerVideo">
      <video :ref="nombreVideo" autoplay controls disableRemotePlayback :controlslist="controls">
        <source :src="urlVideo" type="video/mp4" />
        <track kind="subtitles" src="" />
      </video>
    </div>
  </div>
</template>
<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";
import PIcon from "@/components/look/PIcon/PIcon.vue";

@Component({
  components: {
    PIcon,
  },
})
export class VideosMaximizedForm extends Vue {
  @Prop({ required: true }) show!: boolean;
  @Prop({ required: true }) nombreVideo!: string;
  @Prop({ required: true }) urlVideo!: string;
  @Prop({ required: true }) descripcionConfidencial!: string;
  @Prop({ required: true }) controls!: string;
}

export default VideosMaximizedForm;
</script>
<style lang="scss" scoped>
.container_VideosPlayForm {
  margin: -1rem;
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  z-index: 9;
  background-color: black;
  bottom: 0;
}

.containerVideo {
  display: flex;
  justify-content: center;

  video {
    width: 100vw;
    height: 100vh;
  }
}

.textMessage_VideosPlayForm {
  display: flex;
  justify-content: center;
  font-size: 20.4px;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;

  span {
    padding: 0 1rem;
    background-color: white;
    margin: auto;
  }
}

.containerClose {
  position: fixed;
  right: 0;
  z-index: 1;

  .spanClose {
    span {
      padding: 1rem;
      cursor: pointer;
    }
  }
}

video::-webkit-media-controls-fullscreen-button {
  display: none;
}
</style>
